import React from 'react';
import { gql } from '@soundxyz/gql-string';
import {
  RELEASE_PLAYLIST_ACTION_TYPE,
  ReleasesPlaylistList,
} from '@components/Feed/ListViews/Playlist/ReleasesPlaylist';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, ReleaseFeedReleasesAddedFragmentDoc } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleaseFeedReleasesAdded on ReleasesAddedToPlaylist {
    id
    date
    numAddedReleases
    playlist {
      id
      ...PlaylistActivityInfo
    }
    user {
      id
      ...MinimalUser
    }
  }
`);

export const ReleasesAddedList = ({
  activityFrag,
}: {
  activityFrag: FragmentType<ReleaseFeedReleasesAddedFragmentDoc>;
}) => {
  const {
    id: actionId,
    playlist,
    numAddedReleases,
    user,
    date,
  } = getFragment(ReleaseFeedReleasesAddedFragmentDoc, activityFrag);

  if (!playlist) {
    return null;
  }

  return (
    <ReleasesPlaylistList
      actionId={actionId}
      userFrag={user}
      playlistFrag={playlist}
      featuredReleases={null}
      isoDateString={date}
      releaseCount={numAddedReleases}
      actionType={RELEASE_PLAYLIST_ACTION_TYPE.RELEASE_ADDED}
      releaseFeed
    />
  );
};
